import './App.css';
import Editor2d from "./components/Editor/editor2d";
import Toolbar from "./components/Palettes/Toolbar/toolbar";
import Statusbar from "./components/Palettes/Statusbar/statusbar";
import Propertybar from "./components/Palettes/Propertybar/propertybar";
import Ribbon from './components/Palettes/Headerbar/Ribbon';
import FetchData from './plan_file_handling/import_file/fetchData';
import PostData from './plan_file_handling/export_file/postData';
import logo from './components/pictures/eptar_logo.png'
import { useAppSelector, useAppDispatch } from './store/hooks';
import LayerSettingsModal from './components/Editor/modals/layer_settings/LayerSettingsModal';
import { useEffect } from "react"
import { RootState } from "./store/store";
import queryString from 'query-string';
import _ from "lodash";
import "./components/Editor/util/event/eventRegistrySingleton"; // for sideeffect
import { LoadJSONData, LoadOption, sendParentPostMessage } from './store/ioThunk';
import FloatingPalette from './components/Editor/modals/FloatingPalette/FloatingPalette';
import { interfaceMouseOverMainContainer } from './store/interface';
import EventHandler from './components/Editor/util/event/EventHandler';
import EventUserExample from './components/Editor/util/event/EventUserExample';

const App = () => {
  const queryValues = queryString.parse(window.location.search, { parseBooleans: true });
  const saving = useAppSelector((state: RootState) => state.interaction.UIInteraction.saveInProgress)
  const loading = useAppSelector((state: RootState) => state.interaction.UIInteraction.loadingInProgress)
  const layerModalOpen = useAppSelector((state: RootState) => state.interaction.layerEditorModal.open)
  const dispatch = useAppDispatch();
  const model = useAppSelector((state: RootState) => state.model.present.model);

  useEffect(() => {
    const onMsg = (event: any) => {

      const incoming = _.cloneDeep(event.data);
      if (incoming.command === "loadTheStuff") {
        let args: LoadOption[] = [];
        if (incoming?.options?.fitToScreen) args.push("fitToScreen")
        dispatch(LoadJSONData(incoming, args));
      }
      else if (incoming.command === "gimmeTheStuff") {
        dispatch(sendParentPostMessage("doSomethingWithIt", '*'))
      }
    };
    window.addEventListener('message', onMsg);

    return () => {
      window.removeEventListener('message', onMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [model, dispatch]);

  return (
    <div
      role="region"
      aria-label="Main container"
      className='main-container'
      onMouseMove={e => dispatch(interfaceMouseOverMainContainer({ x: e.clientX, y: e.clientY }))}>
      {loading && <FetchData />}
      {saving && <PostData />}
      <EventHandler />
      <EventUserExample />
      <div className="app-container">
        <div className='top-navigation'>
          <a href='https://www.eptar.hu'>
            <img alt='Eptar Logo' className='topnav_logo' src={logo} />
          </a>
        </div>
        <div className='editor'>
          <Editor2d />
        </div>
        <div className='ribbon'>
          <Ribbon
            hideOpenButton={!!queryValues.hideIO}
            hideSaveButton={!!queryValues.hideIO}
          />
        </div>
        <div className='toolbar'>
          <Toolbar />
        </div>
        <div className='statusbar'>
          <Statusbar />
        </div>
        <div className='sidepanel'>
          <Propertybar />
        </div>
        <div>
          <FloatingPalette />
        </div>
      </div>
      {layerModalOpen && <LayerSettingsModal />}
    </div>
  );
}

export default App;
